import { render, staticRenderFns } from "./KegiatanPelayananPembedahan.vue?vue&type=template&id=31d95221"
import script from "./KegiatanPelayananPembedahan.vue?vue&type=script&lang=js"
export * from "./KegiatanPelayananPembedahan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31d95221')) {
      api.createRecord('31d95221', component.options)
    } else {
      api.reload('31d95221', component.options)
    }
    module.hot.accept("./KegiatanPelayananPembedahan.vue?vue&type=template&id=31d95221", function () {
      api.rerender('31d95221', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/KegiatanPelayananPembedahan.vue"
export default component.exports